import { Fragment, useEffect, useState } from "react";
import {
  ArrowDownCircleIcon,
  ArrowPathIcon,
  ArrowUpCircleIcon,
} from "@heroicons/react/20/solid";
import { ChevronDownIcon } from "@heroicons/react/16/solid";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { EllipsisHorizontalIcon } from "@heroicons/react/20/solid";


import { toast, ToastContainer } from "react-toastify";
import CorrectIcon from "../Assets/Icons/Icons";
import PendingApproval from "../Assets/Icons/PendingApproval";
import PendingIcon from "../Assets/Icons/PendingIcon";
import { GetSectionsLookUps, SendResetEmailTemporaryPassword } from "./API/PermissionServices";
import { Loader2Icon } from "lucide-react";
import Loader from "../../LoadingIcons/Loader";
import Drawer from "./Components/Drawer";
import CreateUserDrawer from "./Components/CreateUserDrawer";

const statuses = {
  Paid: "text-green-700 bg-green-50 ring-green-600/20",
  Pending: "text-orange-700 bg-yellow-100 ring-red-600/10",
  Overdue: "text-red-700 bg-red-50 ring-red-600/10",
  PendingApproval: "text-blue-700 bg-blue-100 ring-red-600/10",
};

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const UserAccess = () => {
  const [isLoading, setLoading] = useState(false);
  const [isFormLoading, setFormLoading] = useState(false);
  const [ShortLink, setShortLink] = useState("");
  const [isViewLoading, setViewLoading] = useState(false);


  const [quoteNo, setQuoteNo] = useState("");
  const [debouncedQuoteNo, setDebouncedQuoteNo] = useState(quoteNo);
  const [PolicyDetails, setPolicyDetails] = useState({
    Quote: "",
    ProductName: "",
    TotalAmount: 0,
    Make: "",
    Model: "",
    Plate: "",
    desc: "",
  });

  const [CustomerDetails, setCustomerDetails] = useState({
    FirstName: "",
    lastName: "",
    email: "",
    phone: "", 
    cpr: "",
    expiry: ""
  });
  const [lookupSections, setLookupSections] = useState([]);
const [err, setErr] = useState(null);
   useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        setErr(null);
        const res = await GetSectionsLookUps();
        const data = Array.isArray(res) ? res : Array.isArray(res?.data) ? res.data : [];
        if (!cancelled) setLookupSections(data);
      } catch (e) {
        if (!cancelled) setErr("Failed to load sections lookup.");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);


  const [days, setDays] = useState([]); // State to store transactions grouped by days
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1); // State for total pages
  const [totalItems, setTotalItems] = useState(0); // State for total records
  const [searchString, setSearchString] = useState(""); // State for search string
  const itemsPerPage = 7;

  const [selectedTransaction, setSelectedTransaction] = useState(null); // State for the selected transaction
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenNewRequest, setIsModalOpenOpenNewRequest] = useState(false);






  useEffect(() => {
    const usernameSession = sessionStorage.getItem("username");
    if (usernameSession) {
      fetchSolidarityUsers(); // Fetch the data when the component mounts or search changes
    }
  }, [currentPage]); // Only trigger fetch on page change, not search


 
 


  const fetchSolidarityUsers = async () => {
    const url = process.env.REACT_APP_PAYMENT_API+"Account/GetUsers";
    const data = {
      SearchString: searchString, // Use the search string here
      CurrentPage: currentPage,
      RowsToReturn: itemsPerPage
    };

    try {
      setLoading(true);
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch payment requests");
      }

      const result = await response.json();

      if (result.users && Array.isArray(result.users)) {
        // Handle pagination data from the API response
        setTotalPages(result.pagination.totalPages);
        setTotalItems(result.pagination.totalRecords);

        const sortedTransactions = result.users.sort(
          (a, b) => new Date(a.date) - new Date(b.date)
        );

        const transactions = sortedTransactions.map((request) => ({
          id: request.id,
          client: `${request.userName}`,
          department: request.department,
          position: request.position,
          email: request.email,
          paymentRequestsAccessLevel: request.paymentRequestsAccessLevel,
          createdDate: request.createdDate,
          ext: request.ext,
          phoneNumber: request.phoneNumber,
          requestLimit: request.requestLimit,
          paymentRequestsAccessLevel: request.paymentRequestsAccessLevel,
          hubSections: request.hubSections,
          requestTypes: request.requestTypes,
          profilePicPatth: request.profilePicPatth,
          isActive: request.isActive




        }));

        setDays([{ transactions }]); // Set all transactions under a single group
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching payment requests:", error);
    }
  };

  const currentTransactions = days.flatMap((day) => day.transactions);

  const handleViewTransaction = (transaction) => {
    setSelectedTransaction(transaction); // Set the selected transaction for the modal
    setIsModalOpen(true); // Open the modal
  };

  const closeModal = () => {
    setIsModalOpen(false); // Close the modal

    setShortLink("");
    setSelectedTransaction(null); // Clear the selected transaction
  };

  const OpenNewRequest = () => {
    setIsModalOpenOpenNewRequest(true); // Open the modal
  };

  const closeNewRequestModal = () => {
    setIsModalOpenOpenNewRequest(false); // Close the modal
  };
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleSearchClick = () => {
    setCurrentPage(1); // Reset to the first page when searching
    fetchSolidarityUsers(); // Call the API with the search string
  };

  const handleSearchChange = (event) => {
    setSearchString(event.target.value); // Update the search string as the user types
  };

  const resetPassword = async (email) => {
    setFormLoading(true);
    var res = await SendResetEmailTemporaryPassword(email);
    if(res.statusCode == 200){
      toast.success(res.message, {
      style: {
        background: "green",
        color: "white",
      },
    });
    }
    setFormLoading(false);
  }

  return (
    <div>
      

      

      {isLoading ? (
        <Loader
        variant="overlay"
        size={28}
        label="Fetching Data..."
      />
      ) : (
        <div className="mt-6 overflow-hidden border-t border-gray-100">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="mb-4 flex gap-x-2">
               
                <CreateUserDrawer lookupSections={lookupSections} setLoading={setLoading} fetchSolidarityUsers={fetchSolidarityUsers} />
              </div>
            <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-none">
              {/* Search Input */}
              <div className="mb-4 flex gap-x-2">
                <input
                  type="text"
                  className="w-full px-4 py-2 border border-gray-300 rounded-md"
                  placeholder="Search transactions"
                  value={searchString}
                  onChange={handleSearchChange}
                />
                <button
                  onClick={handleSearchClick}
                  className="px-4 py-2 bg-indigo-600 text-white rounded-md"
                >
                  Search
                </button>
              </div>

              <table className="w-full text-left">
                <thead className="sr-only">
                  <tr>
                    <th>Amount</th>
                    <th className="hidden sm:table-cell">Client</th>
                    <th>More details</th>
                  </tr>
                </thead>
                <tbody>
                  {currentTransactions.map((transaction) => (
                    <tr key={transaction.id}>
                    
                      <td className="hidden py-5 pr-6 sm:table-cell">
                        <div className="text-sm leading-6 text-gray-900">
                          {transaction.client}
                        </div>
                        <div className="mt-1 text-xs leading-5 text-gray-500">
                          {transaction.email}
                        </div>
                      </td>
                      <td className="hidden py-5 pr-6 sm:table-cell">
                        <div className="text-sm leading-6 text-gray-900">
                          {transaction.department}
                        </div>
                        <div className="mt-1 text-xs leading-5 text-gray-500">
                          {transaction.position}
                        </div>
                      </td>
                      <td className="py-5 text-right">
                        <div className="flex justify-end">
                          {/* <button
                            onClick={() => handleViewTransaction(transaction)}
                            className="text-sm font-medium leading-6 text-indigo-600 hover:text-indigo-500"
                          >
                            View
                            <span className="hidden sm:inline">
                              {" "}
                              Details
                            </span>
                          </button> */}
                          <Drawer userDetails={transaction} lookupSections={lookupSections} setLoading={setLoading} fetchSolidarityUsers={fetchSolidarityUsers} setFormLoading={setFormLoading} isFormLoading={isFormLoading} toast={toast}/>
                        </div>
                        <div className="mt-1 text-xs leading-5 text-gray-500">
                          Created Date{" "}
                          <span className="text-gray-900">
                            # {transaction.createdDate}
                          </span>
                        </div>
                        <div className="mt-1 text-xs leading-5 text-gray-500">
                          Work phone{" "}
                          <span className="text-gray-900 font-semibold">
                            {transaction.ext == undefined || transaction.ext == "" ? 'Not Added': transaction.ext}
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Pagination Controls */}
              <div className="flex justify-between mt-4">
                <button
                  onClick={handlePreviousPage}
                  disabled={currentPage === 1}
                  className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-md disabled:opacity-50"
                >
                  Previous
                </button>
                <span className="self-center text-sm text-gray-700">
                  Page {currentPage} of {totalPages || 1}
                </span>
                <button
                  onClick={handleNextPage}
                  disabled={currentPage === totalPages || totalPages === 0}
                  className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-md disabled:opacity-50"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal for Transaction Details */}
      {isModalOpen && selectedTransaction && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          {
            
            isFormLoading ? <Loader label="Resetting user password..." />: <ul className="gap-x-6 gap-y-8 lg:grid-cols-3 xl:gap-x-8">
            <li className="overflow-hidden rounded-xl border border-gray-200">
              <div className="flex items-center gap-x-4 border-b border-gray-900/5 bg-gray-50 p-6">
               

                <div className="text-sm/6 font-medium text-gray-900">
                  {selectedTransaction.policyNumber ?? selectedTransaction.invoiceNumber}
                </div>
                <Menu as="div" className="relative ml-auto">
                  <MenuButton className="-m-2.5 block p-2.5 text-gray-400 hover:text-gray-500">
                    <span className="sr-only">Open options</span>
                    <EllipsisHorizontalIcon
                      aria-hidden="true"
                      className="size-5"
                    />
                  </MenuButton>
                  <MenuItems
                    transition
                    className="absolute right-0 z-10 mt-0.5 w-32 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                  >
                    <MenuItem>
                      <button
                       onClick={async () => await resetPassword(selectedTransaction.email)}
                        className="block px-3 py-1 text-sm/6 text-gray-900 data-[focus]:bg-gray-50 data-[focus]:outline-none"
                      >
                        Reset
                    
                      </button>
                    </MenuItem>
                    <MenuItem>
                      <a
                        href="#"
                        className="block px-3 py-1 text-sm/6 text-gray-900 data-[focus]:bg-gray-50 data-[focus]:outline-none"
                      >
                        Edit
                        <span className="sr-only">
                          , {selectedTransaction.client}
                        </span>
                      </a>
                    </MenuItem>
                  </MenuItems>
                </Menu>
              </div>

              <dl className="-my-3 divide-y divide-gray-100 px-6 py-4 text-sm/6 bg-white">
               
                <div className="flex justify-between gap-x-4 py-3">
                  <dt className="text-gray-500">Name</dt>
                  <dd className="flex items-start gap-x-2">
                    <div className="font-medium text-gray-900">
                      {selectedTransaction.client}
                    </div>
                  </dd>
                </div>
                <div className="flex justify-between gap-x-4 py-3">
                  <dt className="text-gray-500">Payment Request Limit</dt>
                  <dd className="flex items-start gap-x-2">
                    <div className="font-medium text-gray-900">
                      {selectedTransaction.requestLimit}
                    </div>
                  </dd>
                </div>
                <div className="flex justify-between gap-x-4 py-3">
                  <dt className="text-gray-500">Payment Access Level</dt>
                  <dd className="flex items-start gap-x-2">
                    <div className="font-medium text-gray-900">
                      {selectedTransaction.paymentRequestsAccessLevel}
                    </div>
                  </dd>
                </div>
                <div className="flex justify-between gap-x-4 py-3">
                  <dt className="text-gray-500">Phone Number</dt>
                  <dd className="flex items-start gap-x-2">
                    <div className="font-medium text-gray-900">
                      {selectedTransaction.phoneNumber}
                    </div>
                  </dd>
                </div>
                <div className="flex justify-between gap-x-4 py-3">
                  <dt className="text-gray-500">Email</dt>
                  <dd className="flex items-start gap-x-2">
                    <div className="font-medium text-gray-900">
                      {selectedTransaction.email}
                    </div>
                  </dd>
                </div>
                <div className="flex justify-between gap-x-4 py-3">
                  <dt className="text-gray-500">Department</dt>
                  <dd className="flex items-start gap-x-2">
                    <div className="font-medium text-gray-900">
                      {selectedTransaction.department}
                    </div>
                  </dd>
                </div>
                <div className="flex justify-between gap-x-4 py-3">
                  <dt className="text-gray-500">Position</dt>
                  <dd className="flex items-start gap-x-2">
                    <div className="font-medium text-gray-900">
                      {selectedTransaction.position}
                    </div>
                  </dd>
                </div>
                <div className="flex justify-between gap-x-4 py-3">
                  <dt className="text-gray-500">Created Date</dt>
                  <dd className="flex items-start gap-x-2">
                    <div className="font-medium text-gray-900">
                      {selectedTransaction.createdDate}
                    </div>
                  </dd>
                </div>
                {
                  ShortLink == "" ? (
                    <div></div>
                  ) :
                  (
                    <div className="flex justify-between gap-x-4 py-3">
                  <dt className="text-gray-500">Link</dt>
                  <dd className="flex items-start gap-x-2">
                    <a
                      href={ShortLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="font-medium text-gray-900"
                    >
                      Click to view
                    </a>
                  </dd>
                </div>
                  )
                }
                
                <div className="flex justify-between gap-x-4 py-3">
                  <button
                    onClick={closeModal}
                    className="mt-4 px-4 py-2 bg-red-600 text-white rounded-md"
                  >
                    Close
                  </button>
                <Drawer setLoading={setLoading} isLoading={isLoading} fetchSolidarityUsers={fetchSolidarityUsers} setFormLoading={setFormLoading} isFormLoading={isFormLoading} toast={toast}/>
                </div>
              </dl>
            </li>
          </ul>
          }
          
        </div>
      )}

     
      <ToastContainer />
    </div>
  );
};

export default UserAccess;
